import { EVENT_TYPES } from "./EventPopover"

export function getEventCandidateName(event) {
  let candidateName
  switch (event.type) {
    case EVENT_TYPES.bookingLog:
      candidateName = event.candidate_name
      break
    case EVENT_TYPES.meetingSchedule:
      candidateName = event.candidates[0].candidate_name
      break
    default:
      candidateName = event.candidate?.candidate_name || event.candidate_name
  }
  return candidateName
}
